import React from 'react';
var ToggleContext = React.createContext({});
export default ToggleContext;
